/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_ValidationInputs */



/**
* | output |
* | --- |
* | "Please select a file" |
*
* @param {Preset_Manager_Import_ValidationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_validation = /** @type {((inputs?: Preset_Manager_Import_ValidationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_ValidationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Datei aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите файл.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor seleccione un archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione um arquivo.")
	return /** @type {LocalizedString} */ ("Please select a file")
});